
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import {
    PanelSectionTitle,
    ToolbarCommandButton
} from '../../core';

import ConditionList from './ConditionList';
import DialogAttributeCondition from './DialogAttributeCondition';
import GeometryCondition from './GeometryCondition';

const SearchFormAttributes = ({
    attrConditions,
    generatePolygonDefinition,
    isGeoActive,
    searchDefinition,
    tempFeature,
    onSetGeometry,
    onSetIsGeoActive,
    onSetAttrCondition,
}) => {

    const classNames = mergeStyleSets({
        title: {
        }
    });

    const handleAddCondition = async () => {
        let res = await DialogAttributeCondition.show(searchDefinition.attrs, '', '', '');
        if (res) {
            updateCondition(
                res.name,
                {
                    operator: res.operator,
                    value: res.value
                }
            );
        }
    }

    const handleDeleteCondition = (attrId) => {
        updateCondition(attrId, undefined);
    }

    const handleEditCondition = async (attrId) => {
        const condition = attrConditions[attrId];
        if (condition) {
            let res = await DialogAttributeCondition.show(
                searchDefinition.attrs, attrId, condition.operator, condition.value
            );
            if (res) {
                updateCondition(
                    res.name,
                    {
                        operator: res.operator,
                        value: res.value
                    }
                );
            }
        }
    }

    const handleChangeGeoActive = (active) => {
        if (onSetIsGeoActive) {
            onSetIsGeoActive(active);
        }
    }

    const updateCondition = (attrId, condition) => {
        if (onSetAttrCondition) {
            onSetAttrCondition(attrId, condition);
        }
    }

    return (
        <React.Fragment>
            <Stack.Item align="stretch">
                <PanelSectionTitle title="Podmínky pro vyhledávání" />
            </Stack.Item>
            <Stack.Item align="stretch">
                <GeometryCondition
                    active={isGeoActive}
                    generatePolygonDefinition={generatePolygonDefinition}
                    tempFeature={tempFeature}
                    onChangeActive={handleChangeGeoActive}
                    onSetGeometry={onSetGeometry}
                />
            </Stack.Item>
            <ConditionList
                attrs={searchDefinition.attrs}
                conditions={attrConditions}
                onDeleteCondition={handleDeleteCondition}
                onEditCondition={handleEditCondition}
            />
            <Stack.Item align="end">
                <ToolbarCommandButton items={[{text: 'Přidat', title: 'Přidat novou podmínku pro vyhledávání', onClick: handleAddCondition}]}/>
            </Stack.Item>
        </React.Fragment>
    );
}

export default SearchFormAttributes;
